module.exports = __webpack_public_path__ + "img/error-floor.2bef9e7d.svg";